import React from "react";
import config from "./../config";
import { Link, Hidden } from '@material-ui/core';
import { DateTime } from 'luxon';

export const generateColumns = (constants) => [
    {
        Header: 'Date',
        accessor: 'publishedAt',
        Cell: props => DateTime.fromISO(props.value).toFormat(config.dateFormat)
    },
    {
        Header: 'Title',
        accessor: 'title',
        Cell: props => {
            const linkCell = props.row.cells[2];

            return (
                <>
                    <Hidden only="xs">
                        <div>{props.value}</div>
                    </Hidden>

                    <Hidden smUp>
                        <Link href={config.baseEndpoint + linkCell.value} target="_blank" rel="noopener noreferrer">{props.value}</Link>
                    </Hidden>
                </>
            )
        }
    },
    {
        Header: 'Link',
        accessor: 'url',
        Cell: props => <Link href={config.baseEndpoint + props.value} target="_blank" rel="noopener noreferrer">View article</Link>
    },
    ...constants.pdfDownloadsEnabled ? [{
        Header: 'PDF',
        accessor: 'pdfUrl',
        Cell: ({value}) => value ? <Link href={config.baseEndpoint + value} target="_blank" rel="noopener noreferrer">View document</Link> : <span>&ndash;</span>
    }] : [],
];
